/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationsSearchByRestaurantNameQueryVariables = Types.Exact<{
  query: Types.Scalars['String']['input'];
}>;

export type LocationsSearchByRestaurantNameQuery = {
  readonly __typename?: 'Query';
  readonly searchRestaurants: ReadonlyArray<{
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly isAcceptingOrders: boolean;
    readonly flexMessage: string | null;
    readonly notAcceptingOrdersReason: string;
    readonly sanitaryGradeDisplayText: string | null;
    readonly sanitaryGradeUrl: string | null;
    readonly showOutpostPriceDifferenciationDisclosure: boolean;
    readonly showDeliveryPriceDifferenciationDisclosure: boolean;
    readonly showWarningDialog: boolean | null;
    readonly warningDialogDescription: string | null;
    readonly warningDialogTimeout: number | null;
    readonly warningDialogTitle: string | null;
    readonly hours: {
      readonly __typename: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly asset: { readonly __typename: 'Asset'; readonly url: string };
  }>;
};

export const LocationsSearchByRestaurantNameDocument = gql`
  query LocationsSearchByRestaurantName($query: String!) {
    searchRestaurants(query: $query) {
      __typename
      id
      name
      latitude
      longitude
      slug
      address
      city
      state
      zipCode
      isOutpost
      phone
      isAcceptingOrders
      hours {
        __typename
        formatted
      }
      asset {
        __typename
        url
      }
      flexMessage
      notAcceptingOrdersReason
      sanitaryGradeDisplayText
      sanitaryGradeUrl
      showOutpostPriceDifferenciationDisclosure
      showDeliveryPriceDifferenciationDisclosure
      showWarningDialog
      warningDialogDescription
      warningDialogTimeout
      warningDialogTitle
    }
  }
`;

export function useLocationsSearchByRestaurantNameQuery(
  options: Omit<
    Urql.UseQueryArgs<LocationsSearchByRestaurantNameQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LocationsSearchByRestaurantNameQuery,
    LocationsSearchByRestaurantNameQueryVariables
  >({ query: LocationsSearchByRestaurantNameDocument, ...options });
}
